module.exports = __webpack_public_path__ + "images/emoji/beginner.87fea94286fd6d6927d0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/beginner.png
// module id = G0eA
// module chunks = 24